import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = ['"Yo viví el cambio… y todavía me cuesta explicarlo."', '"Tengo familia afuera y cada llamada es una mezcla de amor y rabia."', '"Me fui por supervivencia, no por ambición."', '"No quiero que mis hijos crezcan sin saber lo que realmente pasó."', '"Estoy cansado de ver cómo lo relativizan."', '"Necesito orden, cronología y verdad, no ruido."'];
export function WhoIsItFor() {
  return <section id="audience" className="py-10 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]" data-id="element-147">
      <div className="max-w-4xl mx-auto" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 sm:mb-12 lg:mb-16" data-id="element-149">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-6 font-serif" data-id="element-150">
            ¿Para quién es este Audiolibro + eBook?
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-zinc-400" data-id="element-151">
            Esto es para ti si al menos UNA de estas frases te identifica:
          </p>
        </motion.div>

        <div className="grid gap-2 sm:gap-4" data-id="element-152">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 sm:gap-4 p-3 sm:p-4 rounded-lg hover:bg-zinc-900/50 transition-colors border-b border-zinc-900 last:border-0" data-id="element-153">
              <div className="mt-0.5 flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-zinc-800 flex items-center justify-center text-[#FFCC00]" data-id="element-154">
                <Check size={12} className="sm:w-3.5 sm:h-3.5" strokeWidth={3} data-id="element-155" />
              </div>
              <p className="text-base sm:text-lg text-zinc-200 italic font-medium" data-id="element-156">
                {item}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="mt-8 sm:mt-12 lg:mt-16 p-5 sm:p-6 lg:p-8 bg-zinc-900 rounded-xl border border-zinc-800 text-center" data-id="element-157">
          <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4" data-id="element-158">
            Lo que este libro NO va a hacer
          </h3>
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-6 text-zinc-400 text-xs sm:text-sm" data-id="element-159">
            <p data-id="element-160">No te va a "entretener" como una novela ligera.</p>
            <p data-id="element-161">No te va a decir lo que quieres oír para sentirte cómodo.</p>
            <p data-id="element-162">No va a convertir el dolor en espectáculo.</p>
          </div>
          <div className="mt-5 sm:mt-8 pt-5 sm:pt-8 border-t border-zinc-800" data-id="element-163">
            <p className="text-base sm:text-lg text-white font-serif" data-id="element-164">
              Este libro hace algo más importante: <br data-id="element-165" />
              <span className="text-zinc-300 font-sans tracking-widest uppercase text-xs sm:text-sm mt-2 block" data-id="element-166">
                nombra. registra. deja constancia.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}